import { WALLET_API } from "constants";
import { fetchApi } from "utils";

export async function vipPrize(body) {
  const data = await fetchApi(`${WALLET_API}/area54-vip`, "post", body);
  return data;
}
